import type { ReactNode } from 'react';
import { useCallback } from 'react';

import type { FormAsyncComboboxProps } from '@/_components';
import { FormAsyncCombobox, PrimaryLink } from '@/_components';

import { useGetRelationshipScoresMutation } from '../apis';
import type { RelationshipScoreQueryLinkerSchema } from '../schemas';

export function RelationshipScoresSelect({
  disabled,
  ...props
}: FormAsyncComboboxProps<RelationshipScoreQueryLinkerSchema>) {
  const getName = useCallback(
    (item?: RelationshipScoreQueryLinkerSchema | null): ReactNode => {
      if (!item) {
        return '';
      }

      const itemName = item.label;

      if (!disabled) {
        return itemName;
      }

      return (
        <PrimaryLink to="/settings/relationship-scores/$id" params={{ id: `${item.id}` }} state={{ naturalBack: true }}>
          {itemName}
        </PrimaryLink>
      );
    },
    [disabled]
  );

  return (
    <FormAsyncCombobox
      {...props}
      itemToString={getName}
      keyExtractor={(item) => item?.id?.toString?.() ?? null}
      useApi={useGetRelationshipScoresMutation}
      disabled={disabled}
    />
  );
}
